export interface OptionalOptions {
    font?: string;
    fontSize?: string;
    fontWeight?: string;
    width?: string;
}

export interface Size {
    width: number;
    height: number;
}

function createDummyElement(text: string, options: Required<OptionalOptions>) {
    const element = document.createElement('div');
    const textNode = document.createTextNode(text);
    element.appendChild(textNode);
    element.style.fontFamily = options.font;
    element.style.fontSize = options.fontSize;
    element.style.fontWeight = options.fontWeight;
    element.style.position = 'absolute';
    element.style.visibility = 'hidden';
    element.style.left = '-999px';
    element.style.top = '-999px';
    element.style.width = options.width;
    element.style.height = 'auto';
    document.body.appendChild(element);
    return element;
}

function destroyElement(element) {
    element.parentNode.removeChild(element);
}

const cache: Record<string, {width: number; height: number}> = {};

const calculateSize = (text: string, options?: OptionalOptions) => {
    if (options === undefined) {
        options = {};
    }

    const nextOptions: Required<OptionalOptions> = {
        font: options.font || 'Times',
        fontSize: options.fontSize || '16px',
        fontWeight: options.fontWeight || 'normal',
        width: options.width || 'auto',
    };
    const cacheKey = JSON.stringify({text, options: nextOptions});
    if (cache[cacheKey]) {
        return cache[cacheKey];
    }

    const element = createDummyElement(text, nextOptions);
    const size: Size = {
        width: element.offsetWidth,
        height: element.offsetHeight,
    };
    destroyElement(element);
    cache[cacheKey] = size;
    return size;
};

export default calculateSize;



// WEBPACK FOOTER //
// ./src/utility/calculate-size.ts